module.exports = __webpack_public_path__ + "static/online_banking_web_app_cover-76b84f710e8aa87184356581e15ef809.png";